<script>
import QueryRunner from "@/services/ad-hoc-query-runner-2";
import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util";
import flywhweelDEUtilFactory from "@/services/flywheel-de-util";
import FolderSelector from "@/components/FolderSelector.vue";
import dataExtensionRootFoldersFactory from '@/services/data-extension-root-folders';
import downloadFiles from "@/services/download-files";
import DERowsTable from '@/components/DERowsTable';
import DescribeDEFieldView, { DescribeDEField } from './DescribeDEField';
import DescribeDEFieldQueryView from './DescribeDEFieldQuery';
import XLSX from "xlsx";
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';


var formGroupsConfig = [
    {
        "key": "customSQLWhereEnabled",
        "label": "Use a custom SQL where clause",
        "attrs": {
            "type": "checkbox",
            "true-value": 'true',
            "false-value": 'false'
        }
    },
    {
        "key": "customSQLWhere",
        "label": "Custom SQL where clause",
        "attrs": {
            "type": "textarea",
            "disabled": true
        },
        "helperText":[
            'Use the alias <code>src</code> to refer to the selected data extension',
            'Omit the <code>where</code>.  Just enter the expression itself.'
        ]
    }
];



export default {
    name: "DescribeDEView",
    components: {
        FolderSelector,
        DescribeDEFieldView,
        DERowsTable,
        DescribeDEFieldQueryView,
        FormInputGroupView
    },
    beforeCreate: function() {
        this.$sfmcDE = flywhweelDEUtilFactory(this);
        this.$sfmcFolder = flywhweelSFMCUtilFactory(this, "folder");
        this.$dataExtensionRootFolders = dataExtensionRootFoldersFactory(this.$store, this.$sfmcFolder);
    },
    data: function() {
        var data = {
            uiState: null,
            uiStates: {
                INIT: 'init',
                LOADING: 'loading',
                SELECT_DE: 'select-de',
                CHECKING_SELECTED_DE: 'check-selected-de',
                CONFIGURE_DESCR: 'configure-descr',
                RUNNING_QUERY: 'running-query',
                RUNNING_QUERY_ERROR: 'running-query-error',
                DESCR_COMPLETE: 'descr-complete'
            },

            forms: {
                config: {
                    inputs: FormInputGroup.makeInputs(formGroupsConfig),
                    values: FormInputGroup.makeValues(formGroupsConfig, {
                        customSQLWhereEnabled: 'false',
                        customSQLWhere: ''
                    })
                }
            },

            rootFolders: [], //this.$dataExtensionRootFolders.foldersAvailable,
            rootFolder: null,
            rootFolder_x: {label: 'Data Extensions', value: 'Data Extensions', ent: false, synchronized: false, canCreateDE: true, id: '3777'},
            rootFolderSelectorDisabled: true,
            
            dataExtensionSrc: null,
            dataExtensionSrc_x: {
                "CategoryID": "309585",
                "Client": {
                    "ID": "100010427"
                },
                "CreatedDate": "2020-05-14T16:52:29.017",
                "CustomerKey": "063D8496-8A57-417B-BB9A-49FEEE807D8E",
                "DeleteAtEndOfRetentionPeriod": "false",
                "Description": null,
                "Fields": {
                    "Field": [
                        {
                            "DefaultValue": null,
                            "FieldType": "Date",
                            "IsPrimaryKey": "false",
                            "IsRequired": "true",
                            "Name": "DateAdded",
                            "Ordinal": "1"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "EmailAddress",
                            "IsPrimaryKey": "true",
                            "IsRequired": "true",
                            "MaxLength": "254",
                            "Name": "Email",
                            "Ordinal": "0"
                        },
                        {
                            "DefaultValue": null,
                            "FieldType": "Text",
                            "IsPrimaryKey": "false",
                            "IsRequired": "false",
                            "MaxLength": "16",
                            "Name": "State",
                            "Ordinal": "2"
                        }
                    ]
                },
                "IsSendable": "true",
                "IsTestable": "false",
                "ModifiedDate": "2020-05-14T18:01:20.987",
                "Name": "20200514_Test_Master",
                "ObjectID": "8a7fe095-3596-ea11-811b-1402ec819bf9",
                "PartnerKey": null,
                "ResetRetentionPeriodOnImport": "false",
                "RetainUntil": null,
                "RowBasedRetention": "false",
                "SendableDataExtensionField": {
                    "Name": "Email",
                    "ObjectID": null,
                    "PartnerKey": null
                },
                "SendableSubscriberField": {
                    "Name": "_SubscriberKey"
                },
                "Status": "None"
            },

            describeFields: [],

            descriptions: [],
            descriptionQueue: [],
            descriptionSeq: 1,

            descriptionQueriesMaxCount: 3,
            descriptionQueries: [],
            QueryRunner
        };

        data.uiState = data.uiStates.INIT;

        return data;
    },
    created: function() {
        this.formConfig = FormInputGroup.util(() => this.forms.config.inputs);
    },
    mounted: function() {
        this.uiState = this.uiStates.LOADING;
        //this.makeFields();
        //this.uiState = this.uiStates.CONFIGURE_DESCR;

        Promise.all([
            this.$dataExtensionRootFolders.getFoldersAvailable()
        ]).then(
            (responses) => {
                this.rootFolders = responses[0];
                this.rootFolder = responses[0][0];
                this.uiState = this.uiStates.SELECT_DE;
                return Promise.resolve();
            }
        );
    },
    watch: {
        rootFolder: function() {
            this.dataExtensionSrc = null;
            this.describeFields = [];
        },
        'forms.config.values.customSQLWhereEnabled': function(valueNew) {
            if (valueNew == 'true') {
                this.formConfig.get('customSQLWhere').attrs.disabled = false;
            } else {
                this.formConfig.get('customSQLWhere').attrs.disabled = true;
            }
        }
    },
    methods: {
        backToSelectDe: function() {
            this.dataExtensionSrc = null;
            this.describeFields = [];
            this.uiState = this.uiStates.SELECT_DE;
        },
        backToConfigureFields: function() {
            this.uiState = this.uiStates.CONFIGURE_DESCR;
        },
        forwardToConfigureFields: function() {
            if (this.dataExtensionSrc !== null) {
                this.uiState = this.uiStates.CONFIGURE_DESCR;
            }
        },

        folderSelectorState: function(state) {
            if ((state == 'unk') || (state == 'loading')) {
                this.rootFolderSelectorDisabled = true;
            } else {
                this.rootFolderSelectorDisabled = false;
            }
        },

        formChangeConfig: function(event) {
            this.forms.config.values[event.key] = event.value;
        },
        normalizeWhereClause: function() {
            var newValue = this.forms.config.values.customSQLWhere.replace(/^\s+/, '');
            if (newValue.substr(0, 'where'.length + 1).toLowerCase().match(/where\s/)) {
                this.forms.config.values.customSQLWhere = newValue.substr('where'.length + 1);
            }
        },

        makeFields: function() {
            this.describeFields = [];
            this.dataExtensionSrc.Fields.Field.forEach((properties) => {
                this.describeFields.push({
                    properties,
                    values: JSON.parse(JSON.stringify(DescribeDEField.defaultValues))
                });
            });
            //console.log(this.describeFields);
        },
        deSelected: function(objectType, object, folder) {
            this.dataExtensionSrc = null;
            this.uiState = this.uiStates.CHECKING_SELECTED_DE;
            this.$sfmcDE.apiCall(
                "retrieve",
                {
                    "complex_filter": this.$sfmcDE.complexFilter(
                        this.$sfmcDE.simpleFilter(
                            'CustomerKey',
                            object.CustomerKey
                        ),
                        'AND',
                        this.$sfmcDE.simpleFilter(
                            'CategoryID',
                            folder.ID
                        )
                    ),
                    "get_columns": true,
                    "single_result": true,
                    "query_all_accounts": true
                }
            ).then(
                (response) => {
                    var fieldsStaging = [], fieldsVisited = {};
                    this.dataExtensionSrc = JSON.parse(JSON.stringify(response.data));
                    //
                    // Remove dup fields - not sure why we have to do this, but some IGO_ DE's come back with multiple
                    // rows for the same field
                    this.dataExtensionSrc.Fields.Field.forEach((field) => {
                        if (!fieldsVisited[field.Name]) {
                            fieldsStaging.push(field);
                            fieldsVisited[field.Name] = true;
                        }
                    });
                    this.dataExtensionSrc.Fields.Field = fieldsStaging;
                    this.makeFields();
                    return Promise.resolve();
                }
            ).then(
                () => {
                    this.uiState = this.uiStates.SELECT_DE;
                }
            );
            //console.log(JSON.stringify(arguments, null, 2));
        },

        updateField: function(fieldKey, formValues) {
            var field = this.describeFields.find((field) => {
                return field.properties.Name == fieldKey;
            });
            field.values = JSON.parse(JSON.stringify(formValues));
        },

        makeQueryTemplateContexts: function() {
            var contexts = [];
            var contextTpl = {
                deSourceName: this.$sfmcDE.normalizeDEName(
                    ((this.$store.getters.bu.isChild && this.rootFolder.ent) ? 'ent.' : '') +
                    this.dataExtensionSrc.Name
                ),
                complete: false,
                results: null
            };
            this.normalizeWhereClause();
            this.describeFields.forEach((field) => {
                if (field.values.groupBy == 'true') {
                    var context = {
                        ...JSON.parse(JSON.stringify(contextTpl)),
                        properties: field.properties,
                        flags: {
                            customWhere: this.forms.config.values.customSQLWhereEnabled == 'true'
                        },
                        values: {},
                        customWhere: this.forms.config.values.customSQLWhere
                    };
                    
                    //
                    // SQL expression as needed
                    context.fieldNameAliased = `src.[${field.properties.Name}]`;
                    context.sqlExpression = context.fieldNameAliased;
                    if (field.properties.FieldType == 'EmailAddress') {
                        if (field.values.groupByDomain == 'true') {
                            context.sqlExpression = (
                                `substring(${context.sqlExpression}, charindex('@', ${context.sqlExpression}) + 1, len(${context.sqlExpression}))`
                            );
                        }
                    } else if (field.properties.FieldType == 'Date') {
                        if (field.values.groupByFormatDate) {
                            if (field.values.groupByFormatDate == 'datediff-month') {
                                context.sqlExpression = (
                                    `datediff(month, ${context.sqlExpression}, getdate())`
                                );
                            } else if (field.values.groupByFormatDate == 'datediff-quarter') {
                                context.sqlExpression = (
                                    `datediff(quarter, ${context.sqlExpression}, getdate())`
                                );
                            } else {
                                context.sqlExpression = (
                                    `format(${context.sqlExpression}, '${field.values.groupByFormatDate}')`
                                );
                            }
                        }
                    } else if (field.properties.FieldType == 'Decimal') {
                        if (field.values.roundDecimal == 'true') {
                            context.sqlExpression = (
                                `round(${context.sqlExpression}, ${field.values.decimalPlacesDecimal})`
                            );
                        }
                    }

                    //
                    // flags.nulls
                    context.flags.nulls = field.values.showNulls == 'true';

                    //
                    // flags.emptyStrings
                    context.flags.emptyStrings = false;
                    if (
                        (field.properties.FieldType == 'Text') &&
                        (field.values.showEmpty == 'true')
                    ) {
                        context.flags.emptyStrings = true;
                    }

                    //
                    // flags.emptyStrings
                    context.flags.showMinMaxLen = false;
                    if (
                        (field.properties.FieldType == 'Text') &&
                        (field.values.showMinMaxLen == 'true')
                    ) {
                        context.flags.minMaxLen = true;
                    }

                    //
                    // flags.minMax
                    context.flags.minMax = false;
                    if (
                        (
                            (field.properties.FieldType == 'Date') &&
                            (field.values.showMinMaxDate == 'true')
                        ) ||
                        (
                            (field.properties.FieldType == 'Number') &&
                            (field.values.showMinMaxNumber == 'true')
                        ) ||
                        (
                            (field.properties.FieldType == 'Decimal') &&
                            (field.values.showMinMaxDecimal == 'true')
                        )
                    ) {
                        context.flags.minMax = true;
                    }

                    //
                    // flags.distinct
                    context.flags.distinct = field.values.showDistinctValues == 'true';

                    //
                    // flags.aggregates
                    context.flags.aggregates = (
                        context.flags.nulls ||
                        context.flags.emptyStrings ||
                        context.flags.minMax ||
                        context.flags.distinct
                    );

                    //
                    // flags.topN
                    context.flags.topN = field.values.showTopN == 'true';
                    context.values.topN = field.values.topN;

                    if (context.flags.aggregates || context.flags.topN) {
                        contexts.push(context);
                    }
                }
            });
            return contexts;
        },

        onDescriptionCompletion: function(fieldName, results) {
            var description = this.descriptions.find((description) => {
                return description.context.properties.Name == fieldName;
            });
            description.complete = true;
            description.results = results;

            var allComplete = true;
            this.descriptions.forEach((description) => {
                allComplete = allComplete && description.complete;
            });

            if (allComplete) {
                this.uiState = this.uiStates.DESCR_COMPLETE;
            } else {
                this.describeNext();
            }
        },
        describeNext: function() {
            var description = this.descriptionQueue.shift();
            if (description) {
                this.descriptionQueries.push(description);
            }
        },
        initDescription: function() {
            //console.log(JSON.stringify(this.makeQueryTemplateContexts(), null, 4));
            var i;
            this.descriptions = this.makeQueryTemplateContexts().map((context) => ({
                context,
                complete: false,
                results: null,
                id: this.descriptionSeq++
            }));

            if (!this.descriptions.length) {
                alert("Please select at least one field to describe.");
                return;
            }

            this.descriptionQueue = ([]).concat(this.descriptions);
            this.descriptionQueries = [];
            this.uiState = this.uiStates.RUNNING_QUERY;
            for (i = 0; i < this.descriptionQueriesMaxCount; i++) {
                this.describeNext();
            }
        },

        downloadToCsv: function() {
            var resultsToRows = (results) => {
                var rows = [], headers = [];
                results.forEach((result) => {
                    var row = [];
                    if (!headers.length) {
                        headers = Object.keys(result);
                        rows.push(headers);
                    }
                    headers.forEach((header) => {
                        row.push(result[header]);
                    });
                    rows.push(row);
                });
                return rows;
            };
            var rows = [];
            this.descriptions.forEach((description, descriptionIdx) => {
                if (description.results.aggregates || description.results.topN) {
                    if (descriptionIdx == 0) {
                        rows.push([`Describe ${this.dataExtensionSrc.Name}`]);
                    }
                    rows.push(['']);
                    rows.push(['Field', description.context.properties.Name]);
                    if (description.results.aggregates) {
                        rows.push(['Aggregates']);
                        rows = rows.concat(resultsToRows(description.results.aggregates));
                    }
                    if (description.results.topN) {
                        rows.push([`Top ${description.context.values.topN} occurring value${(description.context.values.topN > 1) ? 's' : ''}`]);
                        rows = rows.concat(resultsToRows(description.results.topN));
                    }
                }
            });
            var ws = XLSX.utils.aoa_to_sheet(rows);
            return downloadFiles(
                [
                    {
                        name: `${this.dataExtensionSrc.Name}.${QueryRunner.delimiters.comma.extension}`,
                        content: XLSX.utils.sheet_to_csv(ws),
                        type: QueryRunner.delimiters.comma.mimeType
                    }
                ], 
                `${this.dataExtensionSrc.Name}.zip`
            );
        }
    }
}
</script>
<template src="./DescribeDE.html"></template>
<style lang="scss" src="./DescribeDE.scss"></style>